export class LinkCategory {
  id: string;
  // meta: {
  //   'totalCount' : Number
  // };
  type: string;
  attributes: {
    'name': string,
    'description': string
    'version': Number
  };
}
